
import { cn } from "@/lib/utils";
import { useTheme } from "@/hooks/use-theme";
import { useBookingStatuses } from "@/hooks/useBookingStatuses";
import { useIsMobile } from "@/hooks/use-mobile";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface BookingsFilterTabsProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
}

const BookingsFilterTabs = ({ activeFilter, onFilterChange }: BookingsFilterTabsProps) => {
  const { primaryColor } = useTheme();
  const { data: statuses = [], isLoading } = useBookingStatuses();
  const isMobile = useIsMobile();
  
  if (isLoading) {
    return (
      <div className="flex justify-center mb-4">
        <div className="animate-pulse flex space-x-2">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="h-8 w-16 bg-muted rounded-full" />
          ))}
        </div>
      </div>
    );
  }

  // Create filter tabs from database statuses plus "all"
  const filterTabs = [
    { id: "all", label: "All" },
    ...statuses.map(status => ({
      id: status.status_key,
      label: status.display_name
    }))
  ];
  
  return (
    <div className="w-full">
      <Select value={activeFilter} onValueChange={onFilterChange}>
        <SelectTrigger className="w-full h-10">
          <SelectValue placeholder="Filter bookings" />
        </SelectTrigger>
        <SelectContent className="bg-popover border-border z-50">
          {filterTabs.map(tab => (
            <SelectItem key={tab.id} value={tab.id}>
              {tab.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default BookingsFilterTabs;
